import { findNoteHelper } from '../js/noteTemplates/noteHelpers'

export default [
  {
    path: '/',
    component: () => import('../layouts/beforeLogin'),
    children: [
      {
        path: '',
        component: () => import('../pages/index'),
        meta: { title: route => 'Submind: Home' }
      }
    ]
  },
  {
    // For backward compatibility.  The manifest had entry-point as index.html.
    path: '/index.html',
    redirect: '/'
  },
  {
    path: '/home',
    component: () => import('../layouts/Default'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('../pages/home'),
        meta: { title: route => 'Submind: Home' }
      },
      {
        path: ':id',
        component: () => import('../pages/editNote'),
        meta: { title: route => 'Submind: ' + findNoteHelper(route.params.id).name }
      }
    ]
  },
  {
    path: '/public/notes',
    component: () => import('../layouts/Default'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('../pages/home'),
        meta: { title: route => 'Submind: Home' }
      },
      {
        path: ':id',
        component: () => import('../pages/showPublicNote'),
        meta: { title: route => 'Submind: ' + route.params.id }
      }
    ]
  },
  {
    path: '/components',
    component: () => import('../layouts/Default'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('../pages/components'),
        meta: { title: route => 'Submind: Components' }
      },
      {
        path: ':id/edit',
        component: () => import('../pages/componentEditor'),
        meta: { title: route => 'Submind: Component ' + route.params.id }
      }
    ]
  },
  {
    path: '/public-components',
    component: () => import('../layouts/Default'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('../pages/publicComponents'),
        meta: { title: route => 'Submind: Components' }
      },
      {
        path: ':id',
        component: () => import('../pages/showPublicComponent'),
        meta: { title: route => 'Submind: Public Component ' + route.params.id }
      }
    ]
  },
  {
    path: '/noteTemplates',
    component: () => import('../layouts/Default'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        component: () => import('../pages/noteTemplates'),
        meta: { title: route => 'Submind: Note Templates' }
      },
      {
        path: ':id/edit',
        component: () => import('../pages/noteTemplateEditor'),
        meta: { title: route => 'Submind: Note Template ' + route.params.id }
      }
    ]
  },
  {
    path: '/docs',
    component: () => import('../layouts/docs'),
    meta: { requiresAuth: false },
    children: [
      {
        path: 'home',
        component: () => import('../pages/docs/home'),
        meta: { title: route => 'Submind Docs: Home' }
      },
      {
        path: 'interface',
        component: () => import('../pages/docs/interface'),
        meta: { title: route => 'Submind Docs: Interface' }
      },
      {
        path: 'notes',
        component: () => import('../pages/docs/notes'),
        meta: { title: route => 'Submind Docs: Notes' }
      },
      {
        path: 'components',
        component: () => import('../pages/docs/components'),
        meta: { title: route => 'Submind Docs: Components' }
      },
      {
        path: '../components/this-component',
        component: () => import('../pages/docs/thisComponent'),
        meta: { title: route => 'Submind Docs: This Component $tc' }
      },
      {
        path: '../components/component-helper',
        component: () => import('../pages/docs/componentHelper'),
        meta: { title: route => 'Submind Docs: Component Helper $ch' }
      },
      {
        path: 'note-templates',
        component: () => import('../pages/docs/noteTemplates'),
        meta: { title: route => 'Submind Docs: Note Templates' }
      },
      {
        path: 'public-notes',
        component: () => import('../pages/docs/publicNotes'),
        meta: { title: route => 'Submind Docs: Public Notes' }
      },
      {
        path: 'tech',
        component: () => import('../pages/docs/tech'),
        meta: { title: route => 'Submind Docs: The Tech Driving Submind' }
      }
    ]
  },
  { // Always leave this as last one
    path: '*',
    component: () => import('../pages/404'),
    meta: { title: route => 'Submind: 404' }
  }
]
